export default {
  methods: {
    getTextSasAdresseDropdown(sasAdresse) {
      const value = sasAdresse.id
      let text
      if (!sasAdresse.adressePersonnelle) {
        text = [sasAdresse.organisation, sasAdresse.rue1, sasAdresse.codePostal].filter(s => s).join(" - ")
      } else {
        text = [sasAdresse.organisation, sasAdresse.rue1, sasAdresse.codePostal].filter(s => s).join(" - ")
      }
      return { value, text }
    },
  }
}